export default __webpack_public_path__ + "static/media/big-laugh.7bca538b.jpg";